import Request from './request';
import * as query from "@arcgis/core/rest/query";
import Query from "@arcgis/core/rest/support/Query";
import FieldNames from '../defaults/FieldNames.json';
import GeneralService from './GeneralService';
import { getAppConfig, getAttributeServiceUrl, getNifcToken } from '../utils/ReduxHelper';

const FundingService = {
    getFundingByJoinID: function (joinId, joinFeature, outFields = "*") {
      try
      {
        const rootServiceUrl = getAttributeServiceUrl();
        const config = getAppConfig();
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId;
        let whereClause = `((${FieldNames.fundingFields.joinID} = ${joinId}) AND (${FieldNames.fundingFields.joinFeature} = '${joinFeature}'))`;

        const queryObject = new Query({
          where: whereClause,
          outFields: outFields,
        });

        return query.executeQueryJSON(url, queryObject).then(results => {
          let fundingItems = [];
          if(results.features) {
            fundingItems = results.features.map((eaItem) => eaItem.attributes);
          } 
          return(fundingItems)
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    getFundingByJoinIDs: function (joinIDs, joinFeature) {
      try
      {
        const config = getAppConfig();
        const rootServiceUrl = getAttributeServiceUrl();
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId;
        let whereClause = "1=1";
        if(joinIDs && joinIDs.length > 0){
          whereClause = `(JoinID IN (${joinIDs.join(", ")}) AND (${FieldNames.fundingFields.joinFeature} = '${joinFeature}'))`
          const queryObject = new Query({
            where: whereClause,
            outFields: "*",
          });
    
          return query.executeQueryJSON(url, queryObject).then(results => {
            let fundingItems = [];
            if(results.features) {
              fundingItems = results.features.map((eaItem) => eaItem.attributes);
            } 
            return(fundingItems)
          });
        }
        else
        {
          return new Promise((resolve) => {
            resolve([]);
          })
        }
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    // TODO: Currently only used by another unused method. Delete by 1.8 if no use case for that found.
    getFundingByBatchedFeatureJoinIDs: async function (rootServiceUrl, joinIds, config, definitionExpression = null, outfields="*") {
      try
      {
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId;
      
        if(joinIds?.length > 0){
          let allFinalResults = [];
          const numberToTakeEachTime = 2000;
          let startIndex = 0;
          let hasMoreRecords = true;
          let finalResults = "";
  
          while(hasMoreRecords){
            try{
              let endIndex = startIndex + numberToTakeEachTime;
              let entityIdBatch = [];
              entityIdBatch = joinIds.slice(startIndex, endIndex);
              let entityIdBatchStr = "" + entityIdBatch.join(",") + "";
              let batchWhere = definitionExpression ? `((${FieldNames.fundingFields.joinID} IN (${entityIdBatchStr}) AND (${FieldNames.fundingFields.joinFeature} = '${FieldNames.joinFeatureValues.polygon}')) AND ${definitionExpression})` : 
                `(${FieldNames.fundingFields.joinID} IN (${entityIdBatchStr}) AND (${FieldNames.fundingFields.joinFeature} = '${FieldNames.joinFeatureValues.polygon}'))`;
    
              const queryObject = new Query({
                where: batchWhere,
                orderByFields: "OBJECTID DESC",
                outFields: outfields,
                returnGeometry: false,
                num:numberToTakeEachTime
              });
              
              finalResults = await GeneralService.queryCall(url, queryObject);
              if(finalResults && finalResults.length > 0){
                allFinalResults.push(finalResults)
              }
            } catch(e){
              throw e;
            }
            hasMoreRecords = joinIds.length > (startIndex + numberToTakeEachTime);
            startIndex += numberToTakeEachTime;
          }

          const allFinalResultsFlattened = (allFinalResults != null && allFinalResults.length > 0) ? allFinalResults.flat() : [];
          return(allFinalResultsFlattened);
  
        } else
        {
          return new Promise((resolve) => {
            resolve([]);
          })
        }
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    getFundingByFundingObjectIDs: function (rootServiceUrl, fundingObjectIds, config) {
      try
      {
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId;
        let whereClause = "1=1";
        let objectIds = [];
        fundingObjectIds.forEach((objId) => {
          if(objId){
            objectIds.push(objId);
          }
        });
        if(objectIds && objectIds.length > 0){
          whereClause = `(OBJECTID IN (${objectIds.join(", ")}))`;
        
          const queryObject = new Query({
            where: whereClause,
            outFields: "*",
          });
    
          return query.executeQueryJSON(url, queryObject).then(results => {
            let fundingItems = [];
            if(results.features) {
              fundingItems = results.features.map((eaItem) => eaItem.attributes);
            } 
            return(fundingItems)
          });
        }
        else
        {
          return new Promise((resolve) => {
            resolve([]);
          })
        }
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    updateFundingEntries: function (fundingEntries){
      try
      {
        const rootServiceUrl = getAttributeServiceUrl();
        const config = getAppConfig();
        const nifcToken = getNifcToken();
        
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId + "/updateFeatures";
        return new Promise((resolve, reject) => {
          let adjustedFundingEntries = [];
          fundingEntries.forEach((feature) => {
            const newFundingEntry = {
              attributes: feature
            };
            adjustedFundingEntries.push(newFundingEntry);
          });
            
          new Request().makeRequest({
            url: url,
            method: 'post',
            data: {
                f: 'json',
                token: nifcToken,
                features: JSON.stringify(adjustedFundingEntries)
            }
          }).then(
              resp => {
                resolve(resp);
              },
              error => {
                reject(error)
              }
          );
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    addFundingEntries: function (fundingEntries){
      try
      {
        //Can only update 1 type at a time due to url being different
        const rootServiceUrl = getAttributeServiceUrl();
        const config = getAppConfig();
        const nifcToken = getNifcToken();

        const url = rootServiceUrl + "/" + config.funding[config.env].layerId + "/addFeatures";
        return new Promise((resolve, reject) => {
            let adjustedFundingEntries = [];
            fundingEntries.forEach((feature) => {
              const newFundingEntry = {
                attributes: feature
              };
              adjustedFundingEntries.push(newFundingEntry);
            });
              
            new Request().makeRequest({
              url: url,
              method: 'post',
              data: {
                  f: 'json',
                  token: nifcToken,
                  features: JSON.stringify(adjustedFundingEntries)
              }
            }).then(
                resp => {
                  resolve(resp);
                },
                error => {
                  reject(error)
                }
            );
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
    deleteFundingEntries: function (fundingEntryObjectIds){
      try
      {
        const rootServiceUrl = getAttributeServiceUrl();
        const config = getAppConfig();
        const nifcToken = getNifcToken();
        const url = rootServiceUrl + "/" + config.funding[config.env].layerId + "/deleteFeatures";
        return new Promise((resolve, reject) => {
          const whereArray = [];
          fundingEntryObjectIds.forEach((objectId) => {
            const indWhere = `(OBJECTID=${objectId})`
            whereArray.push(indWhere);
          });
          const whereClause = "(" + whereArray.join(" OR ") + ")";
          new Request().makeRequest({
            url: url,
            method: 'post',
            data: {
                f: 'json',
                token: nifcToken,
                where: whereClause
            }
        }).then(
            resp => {
                resolve(resp)
            },
            error => {
              reject(error)
            }
        );
        });
      }
      catch(e)
      {
        return new Promise((resolve,reject) => {
          reject(e);
        });
      }
    },
};

export default FundingService;